export const USER_ID_HEADER = 'x-user-id'

const STORAGE_KEY = 'x-uid'
const COOKIE_USER_ID = 'x-user-id'
const LEGACY_COOKIE_USER_ID = 'eh_user_id'
const COOKIE_DEVICE_ID = 'x-uid'
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365

const readCookie = (name: string) => {
  if (typeof document === 'undefined') return ''
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]+)`))
  return match ? decodeURIComponent(match[1]) : ''
}

const persistCookies = (userId: string) => {
  if (typeof document === 'undefined') return
  const encoded = encodeURIComponent(userId)
  const cookieConfig = `; Path=/; Max-Age=${ONE_YEAR_SECONDS}; SameSite=Lax`
  document.cookie = `${COOKIE_USER_ID}=${encoded}${cookieConfig}`
  document.cookie = `${LEGACY_COOKIE_USER_ID}=${encoded}${cookieConfig}`
  document.cookie = `${COOKIE_DEVICE_ID}=${encoded}${cookieConfig}`
}

const persistStorage = (userId: string) => {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(STORAGE_KEY, userId)
}

export function syncClientUserId(userId?: string | null) {
  const candidate = userId?.trim()
  if (!candidate) return
  persistCookies(candidate)
  persistStorage(candidate)
}

export function getOrInitClientUserId(): string {
  if (typeof window === 'undefined') return ''

  const fromCookie =
    readCookie(COOKIE_USER_ID) || readCookie(LEGACY_COOKIE_USER_ID) || readCookie(COOKIE_DEVICE_ID)
  if (fromCookie?.trim()) {
    persistStorage(fromCookie.trim())
    return fromCookie.trim()
  }

  const fromStorage = window.localStorage.getItem(STORAGE_KEY)?.trim()
  if (fromStorage) {
    persistCookies(fromStorage)
    return fromStorage
  }

  const generated = (crypto?.randomUUID?.() ?? Math.random().toString(36).slice(2)).toString()
  persistCookies(generated)
  persistStorage(generated)
  return generated
}
